import React from 'react';

const Privacy = () => {
    return (
        <iframe className="term"  src="https://zeely.app/privacyContent.html" frameborder="0"></iframe>
    );
}

export default Privacy;
